export default "__VITE_ASSET__D4DKuV_3__"